import { useState } from "react";
import { CircleNotch, At, Lock, Eye, EyeSlash } from "@phosphor-icons/react";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { useAuth } from "../contextos/AuthContext";

export default function PaginaLogin() {
    const { entrar } = useAuth();
    const [email, setEmail] = useState("");
    const [senha, setSenha] = useState("");
    const [mostrarSenha, setMostrarSenha] = useState(false);
    const [carregando, setCarregando] = useState(false);

    const enviar = async (e) => {
        e.preventDefault();
        setCarregando(true);
        try {
            await entrar(email, senha);
        } catch (err) {
            toast.error(err?.response?.data?.erro || "Falha ao entrar");
        } finally {
            setCarregando(false);
        }
    };

    return (
        <div className="min-h-screen bg-zinc-950 text-zinc-100 bg-grid flex items-center justify-center p-4">
            <div className="w-full max-w-sm">
                <form onSubmit={enviar} className="space-y-4 bg-zinc-900 border border-zinc-800 rounded-lg p-5">
                    <div className="space-y-1.5">
                        <Label htmlFor="email" className="text-xs uppercase tracking-wide text-zinc-400">E-mail</Label>
                        <div className="relative">
                            <At size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-500" />
                            <Input id="email" type="email" required autoFocus autoComplete="email"
                                value={email} onChange={(e) => setEmail(e.target.value)}
                                placeholder="admin@gmail.com"
                                data-testid="input-email-login"
                                className="bg-zinc-950 border-zinc-800 pl-9 focus:border-zinc-600" />
                        </div>
                    </div>
                    <div className="space-y-1.5">
                        <Label htmlFor="senha" className="text-xs uppercase tracking-wide text-zinc-400">Senha</Label>
                        <div className="relative">
                            <Lock size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-500" />
                            <Input id="senha" type={mostrarSenha ? "text" : "password"} required autoComplete="current-password"
                                value={senha} onChange={(e) => setSenha(e.target.value)}
                                placeholder="••••••"
                                data-testid="input-senha-login"
                                className="bg-zinc-950 border-zinc-800 pl-9 pr-9 focus:border-zinc-600" />
                            <button
                                type="button"
                                onClick={() => setMostrarSenha((v) => !v)}
                                data-testid="btn-toggle-senha"
                                aria-label={mostrarSenha ? "Ocultar senha" : "Mostrar senha"}
                                title={mostrarSenha ? "Ocultar senha" : "Mostrar senha"}
                                className="absolute right-2 top-1/2 -translate-y-1/2 text-zinc-500 hover:text-zinc-200 p-1 transition-colors"
                            >
                                {mostrarSenha ? <EyeSlash size={14} /> : <Eye size={14} />}
                            </button>
                        </div>
                    </div>
                    <Button type="submit" disabled={carregando}
                        data-testid="btn-entrar"
                        className="w-full bg-white text-zinc-950 hover:bg-zinc-200 font-medium">
                        {carregando ? <CircleNotch size={16} className="animate-spin mr-2" /> : null}
                        {carregando ? "Entrando…" : "Entrar"}
                    </Button>
                </form>
            </div>
        </div>
    );
}
